const ShortcutsUiText = {
  "General Actions (PC & Mac)": {
    "Undo": "Ctrl + Z",
    "Redo": "Ctrl + Y",
  },
  "Multiple Tooth Selection(PC & Mac)":{
    "Select multiple teeth":"Ctrl + Left Click"
  },
  "Playback & Animation(PC & Mac)":{
    "Play/pause staging":"Spacebar",
    "Initial / Current switch (I/C)":"R"
  },
  "Viewing(PC & Mac)":{
    "Left view": "1",
    "Front view": "2",
    "Right view":"3",
    "Back view":"4",
    "Upper arch only":"5",
    "Lower arch only":"6"
  },
  "Manual Single Tooth Movement(PC & Mac)":{
    "Move left": "A",
    "Move up": "W",
    "Move down": "S",
    "Move right": "D",
    "Rotation(M)": "Shift+W",
    "Rotation(D)": "Shift+S",
    "Tipping or Torque (per view angle)": "Shift+A,Shift+D"
  },
  "Model Navigation":{
    "Rotate model (PC)": "Right\u0020click\u0020+\u0020drag\u0020on\u0020model",
    "Rotate model (Mac)": "Right\u0020click\u0020+\u0020drag",
    "Pan model (PC)": "Shift\u0020+\u0020Right\u0020click\u0020+\u0020drag",
    "Pan model (Mac)": "Shift\u0020+\u0020⌘\u0020+\u0020Right\u0020click\u0020+\u0020drag",
    "Zoom in/out (PC)": "Mouse\u0020wheel\u0020scroll\u0020up/down"
  },
}
export default ShortcutsUiText